/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sl_New_Source_Dried_DateInputs */

const vi_sl_new_source_dried_date = /** @type {(inputs: Sl_New_Source_Dried_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ngày cân: ${i?.date}`)
};

/**

* @param {Sl_New_Source_Dried_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_source_dried_date = /** @type {((inputs: Sl_New_Source_Dried_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Source_Dried_DateInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_source_dried_date(inputs)
});